import {
  Button,
  ButtonLink,
  PageHeader,
  Stack,
  TextAreaFieldController,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import { getGroupsLink } from '~/utils/getLinks';
import styles from './styles.module.scss';

type Props = {
  /** グループID（パンくず用） */
  groupId: number;
  /** グループ名（パンくず・タイトル用） */
  groupName: string;
  /** 保存ボタンの無効化フラグ */
  isButtonDisabled: boolean;
  /** フォーム送信ハンドラ */
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

/**
 * グループ編集フォームのプレゼンテーションコンポーネント
 *
 * @param groupId - グループID（パンくず用）
 * @param groupName - グループ名（パンくず・タイトル用）
 * @param isButtonDisabled - 保存ボタンの無効化フラグ
 * @param onSubmit - フォーム送信ハンドラ
 * @param onCancel - キャンセルクリックハンドラ
 */
export const EditGroupFormPresentation: React.FC<Props> = ({
  groupId,
  groupName,
  onSubmit,
  isButtonDisabled,
}) => (
  <>
    <PageHeader
      variant='breadcrumb'
      breadcrumbItems={[
        { label: '利用企業', href: '/clients' },
        { label: 'グループ', href: '/groups' },
        { label: groupName, href: `/groups/${groupId}` },
        { label: '編集' },
      ]}
    />
    <div className={styles.content}>
      <span className={styles.content__title}>{groupName}の編集</span>
      <form onSubmit={onSubmit}>
        <Stack direction='column' gap={24} width='466px'>
          <TextInputFieldController
            name='name'
            fieldWrapperProps={{
              labelType: 'required',
              labelText: 'グループ名',
            }}
            textInput={{
              type: 'text',
              placeholder: '例）グループA',
            }}
          />
          <TextInputFieldController
            name='groupId'
            fieldWrapperProps={{
              labelType: 'required',
              labelText: 'グループID',
              beforeMessage: '英数字のみ使用可能。',
            }}
            textInput={{
              type: 'text',
              placeholder: '例）groupA',
            }}
          />
          <TextAreaFieldController
            name='description'
            fieldWrapperProps={{
              labelText: '説明',
              beforeMessage: '200文字まで。',
            }}
            textArea={{
              placeholder: '例）従業員数500名以上',
            }}
          />
          <Stack direction='row' gap={16}>
            <ButtonLink to={getGroupsLink()} variant='outline' size='md'>
              キャンセル
            </ButtonLink>
            <Button type='submit' size='md' disabled={isButtonDisabled}>
              保存
            </Button>
          </Stack>
        </Stack>
      </form>
    </div>
  </>
);
